export const MAX_BULK_REPORT_SELECTION = 200;
